import React, { useState, useRef } from "react";
import './HomePage.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import VideoCard from "../Widgets/VideoCard/VideoCard";

const services = [
    {
        id: "visual",
        title: "可视化数据查看",
        content: [

            "提供全网实时数据监控，掌握数据动态",
            "可视化数据分析，精准定位舆情热点",
            "融合数据挖掘、知识图谱等技术，识别深层次关联",
            "7*24小时监测，预警信息及时推送"
        ],
        image: [
            "/images/组 1902@2x(1).png",
            "/images/组 1904@2x.png"
        ]
    },
    {
        id: "processing",
        title: "四大处理手段",
        content: [
            "一键举报：平台可对不实信息进行处理",
            "一键处置：一键授权并链接网暴涉事媒体投诉中心，简化流程、快速阻断",
            "法律服务：专业律师团队介入，涵盖网络取证协助、委托发函支持及诉讼程序指导等一系列法律咨询服务通道",
            "商务维权：由专业团队提供一系列特色增值服务，维护企业的商誉形象"
        ],
        image: [
            "/images/组 1951@2x.png",
            "/images/组 1950@2x.png"
        ]
    },
    {
        id: "certification",
        title: "在线取证优势",
        content: [
            "通过区块链技术进行线上网络取证",
            "与线下取证具有同等法律效力",
            "可长期保存",
            "支持网页、视频等多种取证方式",
            "便捷高效且价格优惠"
        ],
        image: [
            "/images/组 1952@2x.png",
            "/images/组 1953@2x.png"
        ]
    },
    {
        id: "value-added",
        title: "增值服务",
        content: [
            "网络声誉维护：提供法律手段结果推广、商誉维护与正面引导、商誉及产品推广、特定用户推广等",
            "网络安保服务：提供舆情攻击来源; 企业、品牌、产品、及高管舆情防范; 商誉维护方案; 舆情监控与防范强化；网络安全与信创建设、企业信用修复等咨询服务",
            "人力安保服务:提供企业安保、要员安保、贵重物品押运、涉密文件物品保密销毁等咨询服务",
            "背景核查：提供网络政审; 网络尽职调查; 员工背景、精神状况、忠诚度尽职调查；测谎；电磁环境调查等服务",
            "企业历史舆情修复：提供专业的企业历史舆情咨询和修复服务"
        ],
        image: [
            "/images/组 1955@2x.png",
            "/images/组 1954@2x.png"
        ]
    }
];


const HomePage = (props) => {

    // 创建 ref 用于页面中的各个部分
    const section1Ref = useRef(null);
    const section2Ref = useRef(null);
    const section3Ref = useRef(null);

    // 创建滚动到指定 section 的函数
    const scrollToSection = (sectionRef) => {
        sectionRef.current?.scrollIntoView({
            behavior: 'smooth',  // 平滑滚动
            block: 'start',      // 定位到顶部
        });
    };

    const [selected, setSelected] = useState(services[0].id);
    const [isOpen, setIsOpen] = useState(false);


    return <div className="home-wrapper">
        <div className="nav-bar-wrapper">
            <div className="nav-bar">
            <img className="nav-logo" src="/images/logo.png" alt="Logo">
            </img>
            <div className="nav-inner">
                <span className="nav-inner-item" >首页</span>
                <span className="nav-inner-item" onClick={() => scrollToSection(section1Ref)}>产品服务</span>
                <span className="nav-inner-item" onClick={() => scrollToSection(section2Ref)}>品牌介绍</span>
                <span className="nav-inner-item" onClick={() => scrollToSection(section3Ref)}>联系我们</span>
            </div>
            </div>
        </div>

        <div className="web-body">
            <div className="first">
                <div className="first-button" onClick={() => setIsOpen(true)}></div>
            </div>

            {isOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h5>国信利信大数据科技（北京）有限公司</h5>
                        <ul>
                            <li>
                                <img src="/images/组 1939@2x.png" alt="右侧装饰" className="imgzero" />
                                <span>联系人：代女士</span>
                            </li>
                            <li>
                                <img src="/images/组 1937@2x.png" alt="右侧装饰" className="imgzero" />
                                <span>联系电话：010-6095 8413</span>
                            </li>
                            <li>
                                <img src="/images/组 1938@2x.png" alt="右侧装饰" className="imgzero" />
                                <span>服务时间：9:00 - 18:00</span>
                            </li>
                        </ul>
                        <div className="dividing-line"></div>
                        <button className="confirm-button" onClick={() => setIsOpen(false)}>关闭</button>
                    </div>
                </div>
            )}


            <div className="twice-container">
                {/* 标题部分 */}
                <div className="title">
                    <img src="/images/decoration-left-blue.png" alt="左侧装饰" className="decoration" />
                    <h2>为什么选择我们？</h2>
                    <img src="/images/decoration-right-blue.png" alt="右侧装饰" className="decoration" />
                </div>

                <div className="content1">
                    {/* 三张卡片 */}
                    <div className="cards1">
                        <div className="card1">
                            <div className="card1-header1">
                                <h3>强大的生态体系</h3>
                            </div>
                            <p className="textdec">北京实业开发有限公司作为唯一运营主体，联合国内知名高校实验室、资深律师团队，为用户提供高效、全面的解决方案。</p>
                        </div>
                        <div className="card1">
                            <div className="card1-header2">
                                <h3>领先的技术保障</h3>
                            </div>
                            <p className="textdec">拥有国内领先的技术保障团队。利用国内TOP的大数据平台及 NLP、AI等技术，7×24小时实时监控，为网络置服务提供坚实的技术基础。</p>
                        </div>
                        <div className="card1">
                            <div className="card1-header3">
                                <h3>全面的增值服务</h3>
                            </div>
                            <p className="textdec">提供网络声誉维护、网络安保、人力安保、背景核查、企业信用修复、历史舆情修复等各种支撑服务，为用户提供专业团队支撑。</p>
                        </div>
                    </div>

                    {/* 右侧视频 */}
                    <div className="video-wrapper">
                        {/* <h2>点击播放视频</h2> */}
                        <VideoCard videoSrc="/videos/demo.mp4" coverSrc="/images/videocover.png" />
                    </div>
                </div>
            </div>


            {/* 轮播内容 */}
            <div className="outerplay">
                <div className="content-wrapper" ref={section1Ref}>
                    {/* 标题部分 */}
                    <div className="title tittle-two">
                        <img src="/images/decoration-left-white.png" alt="左侧装饰-白" className="decoration" />
                        <h2>产品服务</h2>
                        <img src="/images/decoration-right-white.png" alt="右侧装饰-白" className="decoration" />
                    </div>
                    <div className="carousel-container">
                        {/* 头部菜单 */}
                        <div className="menu">
                            {services.map((service) => (
                                <button
                                    key={service.id}
                                    className={`menu-item ${selected === service.id ? "active" : ""}`}
                                    onClick={() => setSelected(service.id)}
                                >
                                    {service.title}
                                </button>
                            ))}
                        </div>
                    </div>
                    {services.map((service) => (
                        <div
                            key={service.id}
                            className={`content ${selected === service.id ? "visible" : ""}`}
                        >
                            {/* 半透明遮罩 */}
                            <div className="overlay"></div>

                            {/* 主要内容 */}
                            <div className="content-box">
                                <img src="/images/图标系列3D玻璃风盾牌@2x.png" alt="右侧装饰" className="defence" />
                                <h2>{service.title}</h2>
                                <ul>
                                    {service.content.map((item, index) => {
                                        // 以 "：" 为分隔符拆分内容
                                        const parts = item.split("："); // parts[0] 是前部分，parts[1] 是后部分

                                        return (
                                            <li key={index}>
                                                <span className="content-title">{parts[0]}</span>
                                                <br />
                                                {parts[1] && <span className="content-text">{parts[1]}</span>}
                                            </li>
                                        );
                                    })}
                                </ul>

                            </div>
                            {/* 右侧图片 */}
                            <div className="image-box">
                                <img src={service.image[0]} alt={service.title} />
                                <img src={service.image[1]} alt={service.title} />
                            </div>
                        </div>
                    ))}


                </div>
            </div>

            <div className="title title-second" ref={section2Ref}>
                <img src="/images/decoration-left-blue.png" alt="左侧装饰" className="decoration" />
                <h2>服务供应商</h2>
                <img src="/images/decoration-right-blue.png" alt="右侧装饰" className="decoration" />
            </div>

            <div className="duckdiv">
                <div className="duckinnerdiv">
                    <img src="/images/组 1931@2x.png" alt="右侧装饰" className="duckimg" />
                    <img src="/images/组 1921@2x.png" alt="右侧装饰" className="duckimg" />
                    <img src="/images/组 1920@2x.png" alt="右侧装饰" className="duckimg" />
                    <img src="/images/组 1919@2x.png" alt="右侧装饰" className="duckimg" />
                </div>
            </div>

            <div className="title title-third">
                <img src="/images/decoration-left-blue.png" alt="左侧装饰" className="decoration" />
                <h2>国家政策依据</h2>
                <img src="/images/decoration-right-blue.png" alt="右侧装饰" className="decoration" />
            </div>

            <div className="yiju">
                <span>相关政策和法律法规依据</span>
            </div>

            <div className="ducktwo">
                <div className="buttons-container">
                    <div className="button btn1">《关于加强网络文明建设的意见》</div>
                    <div className="button btn2">《关于依法惩治网络暴力违法犯罪的指导意见》</div>
                    <div className="button btn3">《网络暴力信息治理规定》</div>
                    <div className="button btn4">《网站平台受理处置涉企网络侵权信息举报工作规范》</div>
                </div>
                <div className="image-container">
                    <img src="/images/十权企业法律顾问专题_03@2x.png" alt="法槌" />
                </div>
            </div>

            <div className="footer" ref={section3Ref}>
                <img src="/images/地图.png" alt="地图"></img>
                <div className="contact-container">

                    <h4>联系我们</h4>
                    <p><FaMapMarkerAlt /> 飞利信大厦11层国信利信</p>
                    <p><FaPhone /> 010-6095 8413</p>
                    <p><FaEnvelope /> swd@philisense.com</p>
                </div>

                <img src="/images/qr-code.png" alt="右侧装饰" className="qr-code" />

            </div>
        </div>
    </div>

};


export default HomePage;